import { callBackend } from './api';
import {
  DEFAULT_DARK_THEME,
  DEFAULT_LIGHT_THEME,
  resolveThemeId,
} from '../styles/themeTokens';

export const PREFERRED_THEME_STORAGE_KEY = 'preferredTheme';

export function resolveStoredThemePreference(saved) {
  if (!saved) {
    return DEFAULT_LIGHT_THEME;
  }
  try {
    const parsed = JSON.parse(saved);
    // Preserve migration of the legacy boolean preference.
    if (typeof parsed === 'boolean') {
      return parsed ? DEFAULT_DARK_THEME : DEFAULT_LIGHT_THEME;
    }
    return resolveThemeId(parsed);
  } catch {
    return DEFAULT_LIGHT_THEME;
  }
}

/**
 * Best-effort server persistence of an appearance-prefs slice. The backend
 * shallow-merges top-level keys, so callers can send only the keys they own
 * or the full combined payload. Failures are swallowed — localStorage already
 * holds the value, so server sync is non-fatal.
 *
 * Returns the payload that was sent on success, or `null` on failure. Callers
 * use the return value to advance their "last-persisted snapshot" so a
 * successful write is treated as the new baseline for change detection.
 */
export async function persistAppearancePreferences(partial) {
  try {
    await callBackend('users/appearance-preferences', 'POST', {
      appearance_preferences: partial,
    });
    return partial;
  } catch (err) {
    console.warn('Failed to persist appearance preferences:', err);
    return null;
  }
}
